import React, {useEffect} from 'react'

const ShowMessage = ({
                         isSuccess,
                         isError,
                         message
                     }) => {
    const [show, setShow] = React.useState(false);
    const [color, setColor] = React.useState('');

    useEffect(() => {
        if (isSuccess) {
            setShow(true);
            setColor('green');
        }

        if (isError) {
            setShow(true);
            setColor('red');
        }
    }, [isSuccess, isError]);

    return (
        <>
            {show ? (
                <div
                    className={"text-white px-6 py-4 border-0 rounded relative mb-4 bg-" + color + "-500"}>
                    <span>{message}</span>
                    <button
                        className="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none"
                        onClick={() => setShow(false)}>
                        <span>×</span>
                    </button>
                </div>
            ) : null}

        </>
    )
}

export default ShowMessage
